export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const categories: Category[] = [
  {
    key: 'cat.shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20clean%20white%20minimalist%20sneakers%20with%20subtle%20sage%20green%20details%20displayed%20on%20a%20warm%20cream%20studio%20background%20soft%20diffused%20natural%20lighting%20gentle%20shadow%20editorial%20product%20photography%20for%20an%20e-commerce%20fashion%20website%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-shoes-01&orientation=squarish',
  },
  {
    key: 'cat.hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sage%20green%20hoodie%20sweatshirt%20with%20soft%20fabric%20texture%20placed%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20light%20minimal%20styling%20editorial%20e-commerce%20product%20photography%20for%20a%20fashion%20website%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-hoodies-01&orientation=squarish',
  },
  {
    key: 'cat.tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20plain%20cream%20cotton%20t-shirt%20neatly%20folded%20on%20a%20warm%20beige%20studio%20background%20with%20soft%20natural%20lighting%20and%20a%20gentle%20shadow%20minimalist%20editorial%20product%20photography%20for%20an%20online%20clothing%20store%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-tshirts-01&orientation=squarish',
  },
  {
    key: 'cat.jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-snowy-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20beige%20bomber%20jacket%20displayed%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20studio%20background%20soft%20diffused%20light%20minimal%20editorial%20e-commerce%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-jackets-01&orientation=squarish',
  },
  {
    key: 'cat.pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20beige%20chino%20pants%20with%20crisp%20creases%20placed%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20lighting%20minimalist%20editorial%20product%20photography%20for%20a%20fashion%20website%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-pants-01&orientation=squarish',
  },
  {
    key: 'cat.headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20sage%20green%20baseball%20cap%20with%20a%20simple%20curved%20brim%20displayed%20on%20a%20warm%20cream%20studio%20background%20soft%20diffused%20natural%20light%20minimal%20styling%20editorial%20e-commerce%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-headwear-01&orientation=squarish',
  },
  {
    key: 'cat.sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20outfit%20set%20with%20a%20sage%20green%20sweatshirt%20and%20matching%20sweatpants%20neatly%20arranged%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20lighting%20editorial%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-sets-01&orientation=squarish',
  },
  {
    key: 'cat.underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-handbag-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20stack%20of%20soft%20cotton%20underwear%20in%20neutral%20cream%20and%20beige%20tones%20placed%20on%20a%20warm%20studio%20background%20soft%20diffused%20natural%20light%20minimalist%20editorial%20e-commerce%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-underwear-01&orientation=squarish',
  },
  {
    key: 'cat.jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-team-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20sports%20team%20jersey%20in%20a%20soft%20pastel%20tone%20displayed%20flat%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20for%20an%20e-commerce%20sports%20store%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-jersey-01&orientation=squarish',
  },
  {
    key: 'cat.accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20minimal%20flat%20lay%20of%20fashion%20accessories%20including%20sunglasses%20a%20leather%20watch%20and%20a%20thin%20bracelet%20arranged%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20light%20editorial%20e-commerce%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-accessories-01&orientation=squarish',
  },
  {
    key: 'cat.bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20stylish%20minimalist%20canvas%20tote%20bag%20in%20cream%20and%20sage%20green%20standing%20upright%20on%20a%20warm%20studio%20background%20soft%20diffused%20natural%20light%20editorial%20e-commerce%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-bags-01&orientation=squarish',
  },
  {
    key: 'cat.belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-loop-left-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20rolled%20tan%20leather%20belt%20with%20a%20simple%20metal%20buckle%20placed%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20lighting%20minimalist%20editorial%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-belts-01&orientation=squarish',
  },
  {
    key: 'cat.perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image:
      'https://readdy.ai/api/search-image?query=An%20elegant%20glass%20perfume%20bottle%20with%20a%20soft%20amber%20liquid%20and%20minimal%20label%20on%20a%20warm%20cream%20studio%20background%20soft%20diffused%20light%20editorial%20e-commerce%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-perfumes-01&orientation=squarish',
  },
  {
    key: 'cat.other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-grid-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20assorted%20small%20fashion%20items%20including%20a%20wallet%20a%20keychain%20and%20a%20pair%20of%20socks%20arranged%20on%20a%20warm%20cream%20studio%20background%20soft%20natural%20light%20editorial%20product%20photography%20high%20detail%20airy%20fresh%20aesthetic%20centered%20composition&width=600&height=600&seq=cat-other-01&orientation=squarish',
  },
];

export const SUPPORTED_LANGS = ['en', 'fr', 'de', 'es', 'pt'] as const;

export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
};